/**
 * GuildsSection - Squad/Team Display
 *
 * Shows the squad hub or team-based content for the brand.
 * Integrates with the existing Guild system but displays as "Squads" for branding.
 */

import { FaUsers, FaTrophy, FaChartLine, FaUserPlus } from "react-icons/fa";
import "./GuildsSection.scss";

interface GuildsSectionProps {
    guildId?: string;
}

export const GuildsSection = ({ guildId: _guildId }: GuildsSectionProps) => {
    // Guild integration deferred — requires Guild Competition type (P12)
    return (
        <section className="section guilds-section">
            <div className="section__header">
                <h2>
                    <FaUsers />
                    Squads
                </h2>
                <p>Join forces with other players to compete as a team</p>
            </div>

            <div className="guilds-section__content">
                <div className="guilds-section__coming-soon">
                    <FaUsers size={48} />
                    <h3>Squads Coming Soon</h3>
                    <p>Team-based competitions are being built. Stay tuned!</p>
                </div>
            </div>
        </section>
    );
};
